import axios from 'axios';
import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import {
  MANAGE_SUBS_CHECK_EDIT_ACCOUNT_LOCK_BEGIN,
  MANAGE_SUBS_CHECK_EDIT_ACCOUNT_LOCK_SUCCESS,
  MANAGE_SUBS_CHECK_EDIT_ACCOUNT_LOCK_FAILURE,
  MANAGE_SUBS_CHECK_EDIT_ACCOUNT_LOCK_DISMISS_ERROR,
} from './constants';
import { API_REQUEST_URL } from '../../../common/apiConfig';
export function checkEditAccountLock(args = {}) {
  return (dispatch,getState) => { // optionally you can have getState as the second argument
    dispatch({
      type: MANAGE_SUBS_CHECK_EDIT_ACCOUNT_LOCK_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const cognitoIdToken = getState().home.auth.cognitoIdToken;
      const token = `Bearer ${cognitoIdToken}`;
      const doRequest = axios.post(`${API_REQUEST_URL}/checkEditAccountLock`, args, {
        headers: {
          'Authorization': token,
        }
      });
      doRequest.then(
        (res) => {
          const data = res.data;
          dispatch({
            type: MANAGE_SUBS_CHECK_EDIT_ACCOUNT_LOCK_SUCCESS,
            data: data,
          });
          resolve(data);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          const errorMsg = err && err.response ? err.response.data.message : 'There is an error. Please refresh page or contact administrator.';
          dispatch({
            type: MANAGE_SUBS_CHECK_EDIT_ACCOUNT_LOCK_FAILURE,
            data: { error: errorMsg },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissCheckEditAccountLockError() {
  return {
    type: MANAGE_SUBS_CHECK_EDIT_ACCOUNT_LOCK_DISMISS_ERROR,
  };
}

export function useCheckEditAccountLock() {
  const dispatch = useDispatch();

  const { checkEditAccountLockPending, checkEditAccountLockError } = useSelector(
    state => ({
      checkEditAccountLockPending: state.manageSubs.checkEditAccountLockPending,
      checkEditAccountLockError: state.manageSubs.checkEditAccountLockError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => {
    return dispatch(checkEditAccountLock(...args));
  }, [dispatch]);

  const boundDismissError = useCallback(() => {
    return dispatch(dismissCheckEditAccountLockError());
  }, [dispatch]);

  return {
    checkEditAccountLock: boundAction,
    checkEditAccountLockPending,
    checkEditAccountLockError,
    dismissCheckEditAccountLockError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case MANAGE_SUBS_CHECK_EDIT_ACCOUNT_LOCK_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        checkEditAccountLockPending: true,
        checkEditAccountLockError: null,
      };

    case MANAGE_SUBS_CHECK_EDIT_ACCOUNT_LOCK_SUCCESS:
      // The request is success
      return {
        ...state,
        checkEditAccountLockPending: false,
        checkEditAccountLockError: null,
      };

    case MANAGE_SUBS_CHECK_EDIT_ACCOUNT_LOCK_FAILURE:
      // The request is failed
      return {
        ...state,
        checkEditAccountLockPending: false,
        checkEditAccountLockError: action.data.error,
      };

    case MANAGE_SUBS_CHECK_EDIT_ACCOUNT_LOCK_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        checkEditAccountLockError: null,
      };

    default:
      return state;
  }
}
